//Login.js


import React, { useContext, useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import authServices from '../../services/AuthServices';
import AuthContext from '../../contexts/AuthContext';
import apiClient from '../../api/apiClient';
// import axios from 'axios';

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';


const ForgetPass = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  // const [ShowEye, setShowEye] = useState(false);

  const [mobile, setMobile] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);
      const response = await apiClient.post(`/login/sendOtp_resetpassword`,
        {
          mobile: mobile,
        }
      );

      if (response.data.Status === "SUCCESS") {
        // navigate('/LoginOTP', { state: { token: token } });
        toast.success(response.data.message);
        const token = response.data.data;
        navigate('/Login_otp', { state: { token: token } });

      }
      else {
        toast.error(response.data.message);
      }

    } catch (error) {
      console.error("Login failed");
      toast.error(error.response ? error.response.data.message: error);
    }
    finally{
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-xxl-3 col-lg-4 col-md-5">
        <div className="auth-full-page-content d-flex p-sm-5 p-4">
          <div className="w-100">
            <div className="d-flex flex-column h-100">
              <div className="mb-1 mb-md-5 mt-4 text-center">
                <a href="index.html" className="d-block auth-logo">
                  <img src="assets/images/MMB_LOGO/MMB_LOGO.png" alt="" height={30} />{" "}
                  <span className="logo-txt">MMB</span>
                </a>
              </div>
              <div className="auth-content mt-5">
                <div className="text-center">
                  <h5 className="mt-3">Continue With Number !</h5>

                </div>
                <form className="mt-5 pt-2">
                  <div className="mb-2">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      className="form-control"
                      maxLength={10}
                      id="username"
                      placeholder="Enter Number"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                  </div>

        
                  <div className="row mb-4">
                    <div className="col">

                    </div>
                  </div>
                </form>
                <div className="mb-3">
                  <button
                    className="btn btn-primary w-100 waves-effect waves-light"
                    type="button" onClick={handleLogin}
                    disabled={isSubmitting} // Disable button when isSubmitting is true
                  >
                    {isSubmitting ? 'Processing...' : 'Send OTP'}
                    
                  </button>
                </div>


              </div>
              <div className="mt-4 mt-md-5 text-center">
                <p className="mb-0">
                  © MMB . Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* end auth full page content */}
      </div>
    </>
  );
};

export default ForgetPass;
